// extracted by mini-css-extract-plugin
export default {"setRoomsAndPeople":"_GetRoomsAndPeople_setRoomsAndPeople__NYSRY"};